module.exports = __webpack_public_path__ + "static/media/logo_es_autopistas.580ac06b.svg";